

const getRole = (array) => {
    const arr = array;
    let plan = false;
    let news = false;

    arr.map(row => {
        if(row.loweredRoleName === 'plandeatraque'){
             plan = true;
        }
        if(row.loweredRoleName === 'noticias'){
             news = true;
        }
    })

    return { plan , news };
}

export default getRole;